import React from 'react';
import { useTranslation } from 'react-i18next';
import { PhoneFrame, DemoCaption } from './PhoneFrame';
import { FLAGS } from './assets';
import { GAMES, TEAM_NAMES } from './data';

const K = 'caseStudies.worldCup.knockout';

// Consecutive games of the same stage form one group, the way the
// games list groups by day.
function groupByStage(lang) {
  const groups = [];
  GAMES.forEach((g) => {
    const last = groups[groups.length - 1];
    if (last && last.stage === g.st[lang]) last.games.push(g);
    else groups.push({ stage: g.st[lang], games: [g] });
  });
  return groups;
}

const Team = ({ team, lang }) => (
  <div className="gc-team">
    <div className="gc-logo"><img src={FLAGS[team]} alt="" /></div>
    <div className="gc-name">{TEAM_NAMES[lang][team]}</div>
  </div>
);

// GameCard in its completed state, inside GameList's completed wrapper.
const CompletedCard = ({ game, lang, banner }) => {
  const [s1, s2] = game.s.split('-');
  return (
    <div className="gc-wrap-completed">
      <div className="gc completed">
        <div className="gc-strip"><div className="gc-banner completed">{banner}</div></div>
        <div className="gc-grid">
          <Team team={game.h} lang={lang} />
          <div className="gc-center">
            <div className="pi">
              <div className="score-display">{s1}</div>
              <span className="score-sep">-</span>
              <div className="score-display">{s2}</div>
            </div>
          </div>
          <Team team={game.a} lang={lang} />
        </div>
      </div>
    </div>
  );
};

const KnockoutWidget = ({ lang }) => {
  const { t } = useTranslation();
  return (
    <figure className="demo">
      <DemoCaption title={t(`${K}.title`)} note={t(`${K}.note`)} />
      <PhoneFrame lang={lang}>
        <div className="games-list">
          {groupByStage(lang).map((group) => (
            <div className="day-group" key={group.stage}>
              <div className="game-header"><span className="game-date">{group.stage}</span></div>
              {group.games.map((g) => (
                <CompletedCard key={`${g.h}-${g.a}`} game={g} lang={lang} banner={t(`${K}.fullTime`)} />
              ))}
            </div>
          ))}
        </div>
      </PhoneFrame>
      <div className="demo-foot">
        <p className="games-note">{t(`${K}.footnote`)}</p>
      </div>
    </figure>
  );
};

export default KnockoutWidget;
